import { Trans, useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

export default function PlanPrice(props: {
  price?: {
    period: string;
    value: string;
  };
  title?: string;
  titleAlign?: 'center' | 'left' | 'right';
}) {
  const { t } = useTranslation();

  let content;

  if ('price' in props) {
    content = (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
        }}
      >
        <Typography variant="body1">
          {t('plan-select.price-details.starting-at')}
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            columnGap: '10px',
          }}
        >
          <Typography
            sx={(theme) => ({
              color: theme.palette.secondary.dark,
              fontWeight: 500,
              fontSize: '34px',
              lineHeight: '32px',
              gridColumn: '1 / 2',
              gridRow: '1 / 3',
            })}
          >
            <Trans
              i18nKey="plan-select.price-details.price-per-period"
              values={{
                price: props.price?.value,
                period: props.price?.period,
              }}
              components={{
                1: <span style={{ fontSize: '28px' }} />,
              }}
            />
          </Typography>
        </Box>
      </Box>
    );
  } else {
    content = (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            flexBasis: '100%',
            textAlign: props.titleAlign ?? 'left',
            fontSize: { xs: '28px', sm: '22px' },
          }}
        >
          {props.title}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      }}
    >
      {content}
    </Box>
  );
}
